import { render, staticRenderFns } from "./TabelaGestaoContratoOriginacaoEmpresa.vue?vue&type=template&id=a82974a2&lang=pug"
import script from "./TabelaGestaoContratoOriginacaoEmpresa.vue?vue&type=script&lang=js"
export * from "./TabelaGestaoContratoOriginacaoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./TabelaGestaoContratoOriginacaoEmpresa.vue?vue&type=style&index=0&id=a82974a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports